export var QRCodeStatus = /*#__PURE__*/function (QRCodeStatus) {
  QRCodeStatus["CODE_IS_READY"] = "CODE_IS_READY";
  QRCodeStatus["USER_HAS_SCANNED"] = "USER_HAS_SCANNED";
  QRCodeStatus["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  QRCodeStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  QRCodeStatus["ERROR"] = "ERROR";
  return QRCodeStatus;
}({});
//# sourceMappingURL=wechat-qr-code.js.map